const [ w, d, content ] = [ window, document, 'news' ]

const replace_item = obj => {
  let href = obj.getAttribute('href')
  let thumb = obj.querySelector('.thum_img > img').getAttribute('src')
  let is_new = obj.querySelectorAll('span.new').length > 0 ? true: false
  let catObj = obj.querySelector('.catetitle a')
  let cat = catObj? catObj.innerText : ''
  let dateObj = obj.querySelector('p.date') 
  let date = dateObj? dateObj.innerText : false
  let title = obj.querySelector('h5 > a').getAttribute('title')
  let desc = obj.querySelector('p.catch').innerText
  $(obj).replaceWith(`
    <a class="${content}-item" href="${href}">
      <figure class="${content}-item__img">
        <div class="${content}-item__img-cover" style="background-image:url( ${thumb} )">
          <img src="${thumb}" width="200">
        </div>
      </figure>
      <div class="${content}-item__body">
        ${(catObj)? `<span class="cat"><span>${cat}</span></span>`: '' }
        ${(date)? `<span class="date">${date.replace( /\//g, '.' )}</span>`: '' }
        <h4 class="subject">${title}${(is_new)? '<span class="new">NEW</span>': '' }</h4>
        <p class="desc">${desc}</p>
      </div>
    </a>
  `)
}

const init = () => {

  // カテゴリナビにALLを追加
  let $btn_all = $(`
    <div class="title list_title1 block_title">
      <h4><a href="/${content}/?mode=list">ALL</a></h4>
    </div>
  `)
  $('.block .list_cat').prepend( $btn_all.clone( true ) )
}

const list_init = () => {

  // カテゴリ一覧のカテゴリタイトルを非表示
  $('#main > .element_list .list_title1').remove()
  
  // 記事アイテムのHTMLを組み換え
  let $items = $('.contents .wrapLink','.element_list')
  if( $items.length ) $items.each( (i,item) => replace_item( item ) )

  // カテゴリナビのカレント
  $('.block .list_cat').currentMenu()
}

const detail_init = id => {

  // 日付表記
  let $date = $('.element_detail .detail_title p.date')
  $date.text( $date.text().replace(/\//g,'.') )

}

export default function NEWS () {
  $(() => {
    init()
    if( d.querySelectorAll('.element_list').length ) list_init()
    if( w.query_string('article') ) detail_init( w.query_string('article') )
  })
}